import Markdown from 'markdown-to-jsx'
import React from 'react'

import YoutubeVideo from '@/legacy-src/components/YoutubeVideo'

const ArticleVideo = ({ item }) => {
  return (
    <div className="w-full justify-center">
      <div className="mb-6">
        {item.title && <h2 className="mb-6 font-semibold">{item.title}</h2>}
        {item.content && <Markdown className="text-text-color">{item.content}</Markdown>}
      </div>
      <YoutubeVideo className="max-w-[600px] overflow-hidden rounded-2xl" videoId={item.videoId} />
    </div>
  )
}

export default ArticleVideo
